const vars = {
  APP_NAME: 'FALCON',
  PRIMARY_COLOR: '#2c7be5',
  SKELETON_BACKGROUND: '#D3E4F4',
  PAGINATION_PAGE_SIZE_OPTIONS: [25, 100, 250, 500],
  DEBOUNCE_TIME: 500
};

export default vars;
